import React from "react";
import { Jumbotron, Container } from "reactstrap";
// import { Link } from 'gatsby';

const Example = props => {
  return (
    <div>
      <Jumbotron fluid className="text-light">
        <Container fluid>
          <Container className="dark-overlay pb-2">
            <h1 className="display-4 text-center">
              Commercial Construction and Fit Outs
            </h1>

            <p className="lead text-center">
              A family run company, specialising in retail and leisure fit outs
            </p>
            <hr
              className="my-2 "
              style={{ color: "#fff", backgroundColor: "#fff" }}
            />
            <p className="lead text-center ">
              We deliver quality and unbeatable value - on time and on budget
            </p>
          </Container>
          {/* <div className='row d-flex d-block justify-content-center'>
          <Link className='btn btn-light m-2 px-4' to='/services'>
            Services
          </Link>
          <Link className='btn btn-secondary m-2 px-4' to='/projects'>
            Projects
          </Link>
          <Link className='btn btn-light m-2 px-4' to='/retail'>
            Retail
          </Link>
          <Link className='btn btn-secondary m-2 px-4' to='/leisure'>
            Leisure
          </Link>
        </div> */}
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br className="d-none d-md-block" />
          <br className="d-none d-md-block" />
          <br className="d-none d-md-block" />
          <br className="d-none d-md-block" />
          <br className="d-none d-md-block" />
          <br className="d-none d-md-block" />
        </Container>
      </Jumbotron>
    </div>
  );
};

export default Example;
